import {
  faTrash,
  faChevronDown,
  faChevronUp,
  faDownload,
  faUpload,
  faAdd,
  faEye,
  faFileText,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { colors } from "../../../global";
import { toast } from "react-toastify";
import FileAccordion from "./FileAccordion";
import { v4 as uuidv4 } from "uuid";
import FileToSpreadsheetModal from "../../../shared/components/FileToSpreadsheetModal";

export default function UploadedItemCard({
  file,
  sheetList,
  onDelete,
  onUpdateMetadata,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const [metadataList, setMetadataList] = useState([
    {
      id: uuidv4(),
      file_name: file.name,
      sheet_information: {
        sheet_name: null,
        sheet_id: null,
        name: "",
        service_filter: "",
        service_filter_column: "",
        buffer_percentages: "",
        margin_percentages: "",
        overwrite_sheet: false,
        first_data_row: 1,
        last_data_row: null,
      },
      information_columns: [
        { name: "Ratecard", column: "", hardcodedTo: "" },
        { name: "Service", column: "", hardcodedTo: "" },
        { name: "From Zone", column: "", hardcodedTo: "" },
        { name: "To Zone", column: "", hardcodedTo: "" },
        { name: "", column: "", hardcodedTo: "" },
        { name: "Cubic Conversion", column: "", hardcodedTo: "" },
      ],
      buffer_columns: [
        {
          name: "",
          target_column: "",
          Item_Type: "",
          from: "",
          to: "",
          rename_column: "",
        },
      ],
    },
  ]);

  useEffect(() => {
    onUpdateMetadata(file.name, metadataList);
  }, [metadataList]);

  const handleExport = (e) => {
    e.stopPropagation();
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(metadataList, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "metadata.json";
    link.click();
  };

  const handleImport = (e) => {
    e.stopPropagation();
    const importedFile = e.target.files[0];
    if (!importedFile) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const importedData = JSON.parse(e.target.result);
        const updatedData = importedData.map((data) => ({
          ...data,
          file_name: file.name,
        }));

        setMetadataList(updatedData);
      } catch (err) {
        console.error("Invalid JSON file", err);
        toast.error("Invalid JSON file.");
      }
    };
    reader.readAsText(importedFile);
  };

  const addNewMetadata = () => {
    const newMetadata = {
      id: uuidv4(),
      file_name: file.name,
      sheet_information: {
        sheet_name: null,
        sheet_id: null,
        name: "",
        service_filter: "",
        service_filter_column: "",
        buffer_percentages: "",
        margin_percentages: "",
        overwrite_sheet: false,
        first_data_row: 1,
        last_data_row: null,
      },
      information_columns: [
        { name: "Ratecard", column: "", hardcodedTo: "" },
        { name: "Service", column: "", hardcodedTo: "" },
        { name: "From Zone", column: "", hardcodedTo: "" },
        { name: "To Zone", column: "", hardcodedTo: "" },
        { name: "", column: "", hardcodedTo: "" },
        { name: "Cubic Conversion", column: "", hardcodedTo: "" },
      ],
      buffer_columns: [
        {
          name: "",
          target_column: "",
          Item_Type: "",
          from: "",
          to: "",
          rename_column: "",
        },
      ],
    };

    setMetadataList((prevMetadataList) => {
      return [...prevMetadataList, newMetadata];
    });
  };

  const changedMetadata = (metadata) => {
    setMetadataList((prevMetadataList) => {
      const existingIndex = prevMetadataList.findIndex(
        (item) => item.id === metadata.id
      );

      const updatedList =
        existingIndex !== -1
          ? [
              ...prevMetadataList.slice(0, existingIndex),
              metadata,
              ...prevMetadataList.slice(existingIndex + 1),
            ]
          : [...prevMetadataList, metadata];

      return updatedList;
    });
  };

  const deleteMetadata = (id) => {
    setMetadataList((prevMetadataList) => {
      const updatedList = prevMetadataList.filter((item) => item.id !== id);
      return updatedList;
    });
  };

  const copyMetadata = (id) => {
    const metadata = metadataList.find((x) => x.id === id);
    const newMetadata = {
      ...metadata,
      id: uuidv4(),
    };

    setMetadataList((prevMetadataList) => {
      return [...prevMetadataList, newMetadata];
    });
  };

  const closeModal = () => {
    setIsPreviewModal(false);
  };

  return (
    <>
      {isPreviewModal && (
        <FileToSpreadsheetModal file={file} closeModal={closeModal} />
      )}
      <div
        className="mb-4 overflow-hidden rounded-lg shadow-sm border"
        style={{ borderColor: colors.primary, borderRadius: "0.5rem" }}
      >
        <div
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex flex-wrap justify-between items-center p-3 cursor-pointer rounded-lg"
          style={{ backgroundColor: colors.accent, color: colors.white }}
        >
          <span className="font-medium text-sm truncate max-w-xs sm:max-w-md">
            {file.name}
          </span>
          <div className="flex flex-wrap gap-2 sm:gap-2 items-center mt-3 sm:mt-0">
            <button
              onClick={(e) => {
                e.stopPropagation();
                addNewMetadata();
              }}
              className="bg-white rounded-full p-2 sm:p-3 h-8 flex items-center justify-center hover:opacity-90 transition-opacity"
              style={{ color: colors.primary }}
            >
              <FontAwesomeIcon icon={faAdd} />
              <span className="hidden sm:inline ml-1 text-xs">
                Add New Data
              </span>
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsPreviewModal(true);
              }}
              className="bg-white rounded-full h-8 p-2 sm:p-3 flex items-center justify-center hover:opacity-90 transition-opacity"
              style={{ color: colors.primary }}
            >
              <FontAwesomeIcon icon={faEye} />
              <span className="hidden sm:inline ml-1 text-xs">Preview</span>
            </button>

            <label className="bg-white rounded-full w-8 h-8 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer">
              <FontAwesomeIcon
                icon={faUpload}
                style={{ color: colors.primary }}
              />
              <input
                type="file"
                accept=".json"
                onChange={handleImport}
                className="hidden"
              />
            </label>

            <button
              onClick={handleExport}
              className="bg-white rounded-full w-8 h-8 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
              style={{ color: colors.primary }}
              aria-label="Export"
            >
              <FontAwesomeIcon icon={faDownload} />
            </button>

            {/* Delete Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(file.name);
              }}
              className="bg-white rounded-full w-8 h-8 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
              style={{ color: colors.primary }}
              aria-label="Delete"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded((prev) => !prev);
              }}
              className="text-white w-8 h-8 flex items-center justify-center"
              aria-label={isExpanded ? "Collapse" : "Expand"}
            >
              <FontAwesomeIcon
                icon={isExpanded ? faChevronUp : faChevronDown}
              />
            </button>
          </div>
        </div>

        {isExpanded &&
          (metadataList.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 px-6 text-center bg-gray-50">
              <div className="mb-4">
                <FontAwesomeIcon
                  icon={faFileText}
                  className="w-12 h-12 text-gray-400 mx-auto"
                />
              </div>

              <h3 className="text-lg font-medium text-gray-900 mb-2">
                No metadata found
              </h3>

              <p className="text-gray-500 mb-6 max-w-sm">
                Get started by adding your first metadata entry to organize and
                describe your file content.
              </p>

              <button
                onClick={addNewMetadata}
                className="py-2 px-4 rounded text-sm font-medium"
                style={{ backgroundColor: colors.primary, color: colors.white }}
              >
                <FontAwesomeIcon icon={faPlus} className="w-4 h-4 mr-2" />
                Add Metadata
              </button>
            </div>
          ) : (
            metadataList.map((metadata) => (
              <FileAccordion
                key={metadata.id}
                metadata={metadata}
                file={file}
                sheetList={sheetList}
                onUpdateMetadata={changedMetadata}
                onDeleteMetadata={deleteMetadata}
                onCopyMetadata={copyMetadata}
              />
            ))
          ))}
      </div>
    </>
  );
}
